<elements-image-smart
  [imageUrl]="assetFile | AssetUrl : 'thumbnail' : undefined : 'current' : 'smartcrop' : width : height"
  imageFallbackUrl="/assets/images/Generic_Project_Icon.png"
  *ngIf="assetFile"
  (loaded)="loaded.emit(true)"
  (errored)="errored.emit(true)"
>
  <image-smart-content>
    <ng-container *ngTemplateOutlet="content"> </ng-container>
  </image-smart-content>
</elements-image-smart>

<elements-image-smart imageUrl="/assets/images/Generic_Project_Icon.png" *ngIf="!assetFile">
  <image-smart-content>
    <ng-container *ngTemplateOutlet="content"> </ng-container>
  </image-smart-content>
</elements-image-smart>

<ng-template #content>
  <ng-content select="shared-asset-image-content"> </ng-content>
</ng-template>
